import {AbstractControl, FormArray, FormGroup} from '@angular/forms';
import { DateTime } from 'luxon';
import { PaymentPlanPreview } from './payment-plan-preview.model';
import { PaymentTerm } from './payment-term.model';

const PAYMENT_DATE_FORMAT = 'yyyy-MM-dd';
const ACCEPTED_PAYMENT_DATE_FORMATS = [PAYMENT_DATE_FORMAT, 'M/d/yyyy'];

export class PaymentTermForm {
  payment_dates: Array<string | null>;
  selected_term_id: number;
  selected_term_uuid: string;
  selected_term_name: string;
  customer_service_fee: string;
  initial_payment_amount: string;
  strategy_type: string;
  valid: boolean;
  datePrefix = 'customDates-';

  constructor(form: FormGroup, paymentTerm: PaymentTerm, paymentPlanData: PaymentPlanPreview, isApplied?: boolean) {
    if (form) {
      const controls = this.customDatesControl(String(paymentTerm.id), form)?.controls || '';
      this.selected_term_id = paymentTerm.id;
      this.selected_term_uuid = paymentTerm.uuid;
      this.initial_payment_amount = paymentPlanData ? paymentPlanData.initial_payment_amount : null;
      this.strategy_type = paymentTerm ? paymentTerm.payment_term_strategy.strategy_type : null;
      this.selected_term_name = paymentTerm ? paymentTerm.name : null;
      this.customer_service_fee = paymentPlanData ? paymentPlanData.customer_service_fee : null;
      this.valid = form.status === 'INVALID' ? false : true;
      this.payment_dates = controls ? this.paymentDueDates(controls, paymentTerm, this.valid) : paymentTerm.previewData ?
        this.paymentPlanDueDates(paymentTerm.previewData) : [];
    }
  }

  customDatesControl(id: string, form: FormGroup): FormArray {
    return form.get(this.datePrefix + id) as FormArray;
  }

  paymentDueDates(controls: AbstractControl[], paymentTerm: PaymentTerm, formValid: boolean): Array<string | null> {
    const customDates = this.datePrefix + paymentTerm.id;
    if (controls) {
      return controls.map(item => this.formatDate(item.value.installment));
    }
  }

  formatDate(date: string | null): string | null {
    if (!date) {
      return null;
    }

    for (const format of ACCEPTED_PAYMENT_DATE_FORMATS) {
      const paymentDate = DateTime.fromFormat(date, format);
      if (paymentDate.isValid) {
        return paymentDate.toFormat(PAYMENT_DATE_FORMAT);
      }
    }

    return date;
  }

  paymentPlanDueDates(paymentPlanData: PaymentPlanPreview): Array<string> {
    if (paymentPlanData) {
      return paymentPlanData.payments.map((payment) => {
        if (!payment.upfront_payment) { return payment.due_date; }
      }).filter(date => !!date);
    }
  }
}
